<template>
  <div class="__ListAzureSubscription">
    <ListWrapper
      :data="accounts"
      :filter-keys="['account_name', 'account_id']"
      :filter-placeholder="$t('Search account')"
      :loading="loading"
    >
      <!--Header Actions-->
      <template v-slot:actions>
        <DropdownMenu
          :options="actionMenuOptions"
          position="bottom right"
          @click="handleClickAction"
          v-if="$can('DownloadBulk') && $display('usage_report_download')"
        >
          <template v-slot:activator>
            <CButton icon="save_alt" flat round />
          </template>
        </DropdownMenu>
      </template>

      <!--Body-->
      <template v-slot:body="slotProps">
        <ListItem
          v-for="item in slotProps.data"
          :title="item.account_name"
          :description="
            item.is_subscription
              ? `Subscription ID: ${item.account_id}`
              : `Customer ID: ${item.account_id}`
          "
          :badges="item.badges"
          :key="item.account_id"
          :active="selectedId === item.account_id"
          @click="handleClick(item)"
        >
        </ListItem>
      </template>
    </ListWrapper>

    <!--Dialog-->
    <DialogDownloadBulkCsv v-model="visibleBulkDownloadModal" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import ListWrapper from '@/pages/UsageReport/SideList/ListWrapper';
import ListItem from '@/pages/UsageReport/SideList/ListItem';
import DropdownMenu from '@/components/DropdownMenu';
import CButton from '@/components/uikit/CButton';
import DialogDownloadBulkCsv from '@/pages/UsageReport/SideList/ListAccountDialogDownloadBulkCsv';

const messages = {
  messages: {
    en: {
      'Search account': 'Search account',
      'Report bulk download': 'Download All Reports Data',
    },
    ja: {
      'Search account': 'アカウントを検索',
      'Report bulk download': 'レポート一括ダウンロード',
    },
  },
};

export default {
  name: 'ListAzureSubscription',
  i18n: messages,
  components: { ListWrapper, ListItem, CButton, DropdownMenu, DialogDownloadBulkCsv },
  data() {
    return {
      visibleBulkDownloadModal: false,

      actionMenuOptions: [
        {
          label: this.$t('Report bulk download'),
          actionType: 'bulkDL',
          separate: false,
          icon: null,
        },
      ],
    };
  },
  computed: {
    ...mapState('usageReports', {
      selectedId: state => state.id,
    }),

    ...mapState('accounts', {
      request: state => state.accounts.request,
    }),

    ...mapGetters('accounts', {
      mappingAccountData: 'mappingAccountData',
    }),

    accounts() {
      return this.mappingAccountData;
    },

    loading() {
      return this.request && this.request.inProgress;
    },
  },
  methods: {
    ...mapMutations('accounts', {
      updateSelectedId: 'updateSelectedId',
    }),
    ...mapMutations('usageReports', ['updateIds', 'updateSelectedAccount']),

    handleClick(id) {
      this.updateSelectedId(id.account_id);
      this.updateIds(id.account_ids);
      this.updateSelectedAccount(id);
      this.$emit('click', id.account_id);
    },

    handleClickAction(actionType) {
      if (actionType === 'bulkDL') {
        this.visibleBulkDownloadModal = true;
      }
    },
  },
};
</script>
